(function() {


    let Mensaje = {
        nombre: '',
        email: '',
        mensaje: ''
    }
    
    const btnEnviarForm = document.querySelector('.contacto .submit input[type="submit"]');
    btnEnviarForm.addEventListener('click', validarForm);


    function validarForm(e){
        e.preventDefault();
        const inputNombre = document.querySelector('#nombre');
        const inputEmail = document.querySelector('#email');
        const inputMensaje = document.querySelector('#mensaje');

        let alertas = 0;

        Mensaje.nombre = inputNombre.value;
        inputNombre.classList.remove('formInvalido');
        inputNombre.parentElement.classList.remove('mensajeInvalido');
        if(!Mensaje.nombre){
            inputNombre.classList.add('formInvalido');
            inputNombre.parentElement.classList.add('mensajeInvalido');
            alertas++;
        }

        Mensaje.email = inputEmail.value;
        inputEmail.classList.remove('formInvalido');
        inputEmail.parentElement.classList.remove('mensajeInvalido');
        if(!Mensaje.email){
            inputEmail.classList.add('formInvalido');
            inputEmail.parentElement.classList.add('mensajeInvalido');
            alertas++;
        }

        Mensaje.mensaje = inputMensaje.value;
        inputMensaje.classList.remove('formInvalido');
        inputMensaje.parentElement.classList.remove('mensajeInvalido');
        if(!Mensaje.mensaje){
            inputMensaje.classList.add('formInvalido');
            inputMensaje.parentElement.classList.add('mensajeInvalido');
            alertas++;
        }

        if(alertas <= 0){
            enviarForm();
        }
    }


    async function enviarForm(){
        const url = `${location.origin}/mensajes/crear`;

        const datos = new FormData();
        datos.append('nombre', Mensaje.nombre);
        datos.append('email', Mensaje.email);
        datos.append('mensaje', Mensaje.mensaje);

        try {
            // Se realizar la escritura de datos en la API pasando como parámetros el URL y algunas opciones (body debe ser el objeto que contiene la información que se va a guardar)
            const respuesta = await fetch(url, {
                method: 'POST',
                body: datos
            });
            const resultado = await respuesta.json(); // Se guarda el resultado en formato json en la variable resultado
            if(resultado.resultado){
                Swal.fire({
                    position: 'top-end',
                    icon: 'success',
                    title: 'Tu Mensaje se ha enviado',
                    showConfirmButton: false,
                    timer: 1500
                }).then(() => window.location.reload());
            }
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Something went wrong!',    
            });
        }
    }

})();